import { BrandLoader } from '@/components/common/BrandLoader'
import { jobTypeLabel } from '@/features/ai/lib/jobTypeLabel'
import type { StudioJobType } from '@/features/ai/studioTypes'
import { useMessages } from '@/i18n'
import { messages } from './chatMessages'

interface Props {
  progress: { done: number; total: number | null }
  /**
   * Запись о прогоне есть, а ответа джобы ещё нет. Числа в этот момент —
   * враньё: запись могла пролежать в persist неделю, и «0 из 5» превратилось
   * бы через секунду в итог недельной давности.
   */
  isStatusUnknown: boolean
  /**
   * Прогон, за которым сейчас следит панель — свой или чужой, после
   * «Показать прогон». Подпись обязана совпадать с плашкой занятости,
   * которая называла тот же job_id тем же словарём (`jobTypeLabel`) —
   * Task 8, ревью раунд 1, I-4.
   */
  jobType: StudioJobType | null
}

const capitalize = (s: string): string => s.charAt(0).toUpperCase() + s.slice(1)

const label = (
  m: (typeof messages)['ru'],
  { progress, isStatusUnknown, jobType }: Props,
): string => {
  if (isStatusUnknown) return m.checkingStatus
  const subject = capitalize(jobTypeLabel(jobType))
  return progress.total ? m.progress(subject, progress.done, progress.total) : `${subject}...`
}

/**
 * Единственный индикатор «идёт генерация» — числа `readProgress`, а не
 * фиксированный список шагов: у прогона нет предсказуемого набора фаз
 * (`content` приходит по батчу уроков, шага «картинки» внутри генерации нет
 * вовсе, см. CLAUDE.md). Раньше здесь рисовался список из четырёх шагов
 * мок-движка (`GenerationMessage`) — с реальными данными его нечем наполнить,
 * компонент удалён вместе с ним.
 */
export const GenerationProgress = (props: Props) => {
  const m = useMessages(messages)
  return (
    // Индикатор — такой же бабл ленты, как события прогона: прижат влево и
    // ограничен по ширине (R1, реф `EditorAISidebar.tsx:823`). Без обёртки он
    // растягивался во всю панель и читался как отдельная плашка, а не реплика.
    <div className="flex justify-start">
      <div className="max-w-[90%] space-y-1.5 rounded-2xl rounded-tl-md bg-muted/50 px-3.5 py-3 text-sm text-foreground">
        <div className="flex items-center gap-2">
          <BrandLoader className="size-5" />
          <span>{label(m, props)}</span>
        </div>
        {/* Два свойства прогона, которых автору неоткуда узнать: ручки отмены нет
          (контракт §8.4), а поллер смонтирован выше роутов и реестр лежит в
          persist — запуск переживает и уход из редактора, и закрытие вкладки.
          Пока статус не подтверждён, второе утверждать нельзя: запуск мог уже
          закончиться неделю назад. */}
        {props.isStatusUnknown ? null : (
          <p className="text-xs text-muted-foreground">{m.cantStop}</p>
        )}
      </div>
    </div>
  )
}
